import List from '@utils/list'
const { Search, Jurisdiction, Table } = List

const { Select } = Search

const select = Select.copy('/purchaseUnit/getPurchaseUnitPage').params({
  usingFlag: '1'
})

const search = new Search('qualitycollaboration.checkreturn')
  .placeholder('searchPlaceholder')
  .add('orderType')
  .op('orderType')
  .add('purchaseUnitNo')
  .select(select)
  .lib('dateRange')
  .label('dateRange')
  .prop(['startDocDate', 'endDocDate'])
  .br()
  .add('goodsNo')
  .add('goodsName')
  .add('spec')
const jurisdiction = new Jurisdiction()
  .lib('manual')
  .access('/sysQuartzJob/runCheckReturnJob', process.env.VUE_APP_SCHEDULE_API)

const table = new Table('qualitycollaboration.checkreturn')
  .type('index')
  .add('purCheckReturnNo').label('checkReturnNo').sort(true)
  .add('purCheckReturnDate').date().label('checkReturnDate').sort(true)
  .add('purchaseUnitName').label('purchaseUnitNo').sort(false)
  .add('supplierName').label('supOfficeNo').sort(false)
  .add('orderType').op('orderType').sort(false)
  .add('payTermsName').sort(false)
  .add('tranConditonName').sort(false)
  .add('currencyName').sort(false)
  .add('exchangeRate').sort(false)
  // .lib('remarks')
  .add('checkReturnSeq').html(
    ({ row }) =>
      `${row.purchaseSeq}-${row.purchasePhaseSeq}-${row.purchaseBatchSeq}`
  ).sort(false)
  .add('goodsNo').sort(false)
  .add('goodsName').sort(false)
  .add('spec').sort(false)
  .add('purCheckReturnQty').label('checkReturnQty').sort(false)
  .add('unitName').label('purUnitName').sort(false).format(data => `${data.row.unitNo}-${data.row.unitName}`).width(80)
  .add('purCheckReturnReason').width(150).label('checkReturnReason').sort(false)

export default new List()
  .url('/srmPurCheck/getPurCheckReturnBody', process.env.VUE_APP_PURCHASE_API)
  .jurisdiction(jurisdiction)
  .search(search)
  .table(table)
  .end()
